<body>
  <div class="grid-overlay">
    <app-page-header></app-page-header>

    <div class="reports-data">
      <div><h1>{{ 'appliedCharges.title' | translate }}</h1></div>
      <mat-accordion>
        <mat-expansion-panel [expanded]="isOpenSearchPanel" (opened)="openSearchPanel(true)" [hideToggle]="true">
          <mat-expansion-panel-header>
            <button class="btn-icon btn" title="Buscar" type="button">
              <i class="material-icons">search</i>
            </button>
          </mat-expansion-panel-header>

          <form>
            <fieldset class="fieldset">
              <div fxLayout="row wrap" class="fild_search">

                <!-- Dropdown Compañía / Partner -->
                <div fxFlex="100" fxFlex.gt-xs="25" class="pr-16">
                  <div class="pb-16">
                    <mat-form-field appearance="fill">
                      <mat-label>{{ 'appliedCharges.search.company' | translate }}</mat-label>
                      <mat-select [(ngModel)]="selectedPartnerId"
                        (selectionChange)="onPartnerChange()"
                        [ngModelOptions]="{standalone: true}">

                        @for (p of partners; track p) {
                          <mat-option [value]="(p.id + '')">
                            {{ p.name || p.name_partner || p.business_name || p.id }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <!-- Fecha inicial -->
                <div fxFlex="100" fxFlex.gt-xs="25" class="pr-16">
                  <div class="pb-16">
                    <mat-form-field class="full-width">
                      <input matInput
                        [matDatepicker]="pickerFrom"
                        [placeholder]="'appliedCharges.search.fromDate' | translate"
                        [(ngModel)]="filter.from"
                        name="from"
                        readonly>
                        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                        <mat-datepicker touchUi #pickerFrom></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- Fecha final -->
                  <div fxFlex="100" fxFlex.gt-xs="25" class="pr-16">
                    <div class="pb-16">
                      <mat-form-field class="full-width">
                        <input matInput
                          [matDatepicker]="pickerTo"
                          [placeholder]="'appliedCharges.search.toDate' | translate"
                          [(ngModel)]="filter.to"
                          name="to"
                          readonly>
                          <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                          <mat-datepicker touchUi #pickerTo></mat-datepicker>
                        </mat-form-field>
                      </div>
                    </div>

                    <!-- Autocomplete Archivos procesados -->
                    <div fxFlex="100" fxFlex.gt-xs="25" class="pr-16">
                      <div class="pb-16">
                        <mat-form-field appearance="fill">
                          <mat-label>{{ 'appliedCharges.search.files' | translate }}</mat-label>
                          <input matInput type="text"
                            [formControl]="fileControl"
                            [matAutocomplete]="fileAutocomplete">
                            <mat-icon matSuffix>search</mat-icon>
                            <mat-autocomplete #fileAutocomplete="matAutocomplete"
                              [displayWith]="displayFile"
                              (optionSelected)="selectFile($event.option.value)">
                              @if (loadingFiles) {
                                <mat-option disabled>
                                  {{ 'appliedCharges.messages.loadingFiles' | translate }}
                                </mat-option>
                              }
                              @for (file of fileOptions; track file) {
                                <mat-option [value]="file">
                                  <div class="file-option">
                                    <span class="file-option__name">{{ getFileNameParts(file.fileName).before }}<strong>{{ getFileNameParts(file.fileName).match }}</strong>{{ getFileNameParts(file.fileName).after }}</span>
                                    <span class="file-option__date">{{ formatProcessedFileDate(file.createdAt) }}</span>
                                  </div>
                                </mat-option>
                              }
                              @if (!loadingFiles && fileOptions.length === 0) {
                                <mat-option disabled>
                                  {{ 'appliedCharges.messages.noProcessedFiles' | translate }}
                                </mat-option>
                              }
                            </mat-autocomplete>
                          </mat-form-field>
                        </div>
                      </div>

                      <!-- Estatus de Cobro -->
                      <div fxFlex="100" fxFlex.gt-xs="25" class="pr-16">
                        <div class="pb-16">
                          <mat-form-field appearance="fill">
                            <mat-label>{{ 'appliedCharges.search.chargeStatus' | translate }}</mat-label>
                            <mat-select [(ngModel)]="filter.chargeStatus"
                              name="chargeStatus"
                              required
                              (selectionChange)="onChargeStatusChange()">
                              @for (status of chargeStatusOptions; track status) {
                                <mat-option [value]="status.value">
                                  {{ status.labelKey | translate }}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>

                    </div>
                  </fieldset>

                  <div class="button_report_align" fxLayout="row" fxLayoutAlign="end center">
                    <button
                      mat-raised-button
                      type="button"
                      color="warn"
                      class="ml-16 mr-16 button_report light"
                      (click)="reset()">
                      <mat-icon>refresh</mat-icon>
                    </button>

                    <button
                      mat-raised-button
                      type="button"
                      color="primary"
                      class="ml-16 button_report blue"
                      [disabled]="actionsDisabled"
                      (click)="search()">
                      <mat-icon>search</mat-icon>
                    </button>

                    <button
                      mat-raised-button
                      type="button"
                      color="primary"
                      class="ml-16 button_report blue"
                      [disabled]="actionsDisabled"
                      (click)="downloadExcel()">
                      <mat-icon>download</mat-icon>
                    </button>

                    <!-- TODO: Habilitar cuando el CSV esté funcional
                    <button
                      mat-raised-button
                      type="button"
                      color="primary"
                      class="ml-16 button_report blue"
                      (click)="downloadCsv()">
                      <mat-icon>download</mat-icon>
                    </button>
                    -->
                  </div>
                </form>
              </mat-expansion-panel>
            </mat-accordion>

            <div style="padding-top: 2em;">
              <div class="table-scroll">
                <mat-table [dataSource]="dataSource">

                  <ng-container matColumnDef="partnerName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'appliedCharges.table.partnerName' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="partnerName"> {{ getDisplayValue(row, 'partnerName') }} </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="invoiceCode">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'appliedCharges.table.invoiceCode' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="invoiceCode"> {{row.invoiceCode}} </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="identifierCustomer">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'appliedCharges.table.identifierCustomer' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="identifierCustomer"> {{row.identifierCustomer}} </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="clientName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'appliedCharges.table.clientName' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="clientName">
                      <div class="client-cell">
                        <span class="client-cell__name">{{row.clientName}}</span>
                        @if (row.identifierCustomer) {
                          <span class="client-cell__identifier">
                            {{row.identifierCustomer}}
                          </span>
                        }
                      </div>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="chargeType">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'appliedCharges.table.chargeType' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="chargeType"> {{row.chargeType}} </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalInvoice">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'appliedCharges.table.totalInvoice' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="totalInvoice">
                      <div class="amount-cell">
                        <span class="amount-cell__value">
                          {{row.currency}} {{formatAmount(row.totalInvoice)}}
                        </span>
                        <span class="amount-cell__tax">
                          ITBMS: {{formatAmount(row.itbms)}}
                        </span>
                      </div>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="itbms">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'appliedCharges.table.itbms' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="itbms"> {{row.itbms}} </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="currency">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'appliedCharges.table.currency' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="currency"> {{row.currency}} </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="mask">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'appliedCharges.table.mask' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="mask"> {{row.mask}} </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="createdAtInvoice">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'appliedCharges.table.createdAtInvoice' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="createdAtInvoice"> {{formatTableDateTime(row.createdAtInvoice)}} </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="approvalDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'appliedCharges.table.approvalDate' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="approvalDate"> {{formatTableDateTime(row.approvalDate)}} </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="authorizationNumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'appliedCharges.table.referenceNumber' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="authorizationNumber"> {{row.authorizationNumber}} </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="resultDescription">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'appliedCharges.table.resultDescription' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="resultDescription">
                      <span
                        class="error-description"
                        [matTooltip]="getDisplayValue(row, 'resultDescription')"
                        [matTooltipDisabled]="!getDisplayValue(row, 'resultDescription')"
                        matTooltipShowDelay="400"
                        matTooltipPosition="above">
                        {{ truncateText(getDisplayValue(row, 'resultDescription')) }}
                      </span>
                    </mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
              </div>

              @if (dataSource && dataSource.filteredData && dataSource.filteredData.length === 0) {
                <div class="no-results">
                  {{ 'appliedCharges.table.noResults' | translate }}
                </div>
              }

              <mat-paginator showFirstLastButtons
                [length]="tableService.pager.totalEntities"
                [pageIndex]="tableService.pager.pageIndex"
                [pageSize]="tableService.pager.pageSize"
                [pageSizeOptions]="[20, 50, 100]"
                (page)="list($event)">
              </mat-paginator>
            </div>
          </div>

          <div class="options-buttons">
            <button class="back-btn" (click)="goBack()">{{ 'appliedCharges.buttons.back' | translate }}</button>
          </div>
        </div>
      </body>
